import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { interval, Observable, Subscriber } from 'rxjs';
import { StoreSession } from '../logic/store/session.store';
import { StoreSidemenu } from '../logic/store/sidemenu.store';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private storeSidemenu: StoreSidemenu,
    private storeSession: StoreSession,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.storeSession.isLogin()) {
      return true
    } else {
      this.router.navigate([`/login`])
    }

    return this.storeSession.isLogin()
  }

}
